import FleetTitle from '@/libs/antd/components/Title';
import { useForm } from '@/libs/antd/form';

import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { FleetSearch } from '@/libs/fleet-api/fetcher';
import {
	MonitoringPlafondSearchPOParam,
	useMonitoringPlafondSearchPO,
} from '@/libs/fleet-api/services/monitoring';
import { ArrowLeftOutlined } from '@ant-design/icons';
import {
	Button,
	Col,
	Divider,
	Form,
	Input,
	Row,
	Select,
	Table,
	Typography,
} from 'antd';
import dayjs from 'dayjs';
import { FC, Fragment, useState } from 'react';

const DEFAULT_PARAM: FleetSearch = {
	by: '',
	value: '',
};

type MonitoringPlafondPOProps = MonitoringPlafondSearchPOParam & {
	onBack: () => void;
};
const MonitoringPlafondPO: FC<MonitoringPlafondPOProps> = ({
	mppId,
	onBack,
}) => {
	const { form, fieldName } = useForm<FleetSearch>();
	const [param, setParam] = useState<FleetSearch>({
		...DEFAULT_PARAM,
	});

	const searchAgreementQuery = useMonitoringPlafondSearchPO({
		mppId,
		search: param,
	});
	const { data = [] } = searchAgreementQuery.data ?? {};

	return (
		<Fragment>
			<div
				style={{
					display: 'flex',
					gap: 10,
					marginBottom: 20,
				}}
			>
				{typeof onBack === 'function' && (
					<div>
						<button
							style={{
								display: 'flex',
								height: 44,
								width: 44,
								fontSize: 24,
								border: 'none',
								alignItems: 'center',
								justifyContent: 'center',
								background: '#1557BC',
								color: 'white',
								cursor: 'pointer',
							}}
							onClick={() => onBack?.()}
						>
							<ArrowLeftOutlined />
						</button>
					</div>
				)}
				<div style={{ flex: 1 }}>
					<FleetTitle style={{ marginBottom: 20 }}>
						Monitoring Plafon Exp
					</FleetTitle>
				</div>
			</div>

			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				layout="horizontal"
				colon={false}
				labelAlign="left"
				labelCol={{ style: { width: 160 } }}
				style={{ marginBlock: 20 }}
				onFinish={setParam}
			>
				<Row
					gutter={20}
					wrap={false}
				>
					<Col flex="none">
						<Form.Item
							label="Search by"
							name={fieldName('by')}
						>
							<Select
								allowClear
								style={{ width: 200 }}
								options={[]}
								onSelect={() => {
									form.resetFields([fieldName('value')]);
								}}
								onClear={() => {
									form.resetFields([fieldName('by'), fieldName('value')]);
								}}
							/>
						</Form.Item>
					</Col>
					<Col flex="auto">
						<Form.Item
							name={fieldName('value')}
							noStyle
						>
							<Input />
						</Form.Item>
					</Col>
					<Col flex="none">
						<Button
							block
							style={{ width: 200 }}
							type="primary"
							htmlType="submit"
							disabled={searchAgreementQuery.isFetching}
							loading={searchAgreementQuery.isLoading}
						>
							SEARCH
						</Button>
					</Col>
				</Row>
				<Divider />
			</Form>

			<Typography.Title level={3}>List Purchase Order</Typography.Title>

			<Table
				style={{ marginBlock: 20 }}
				bordered
				scroll={{ x: 'max-content' }}
				loading={searchAgreementQuery.isFetching}
				dataSource={data?.map((record, key) => {
					return {
						...record,
						key,
					};
				})}
				pagination={false}
				columns={[
					{
						title: 'No',
						align: 'center',
						fixed: 'left',
						width: 1,
						render: (_, __, index) => index + 1,
					},
					{
						title: 'No. Simulasi',
						render: (_, record) => record.simulationNo ?? '-',
					},
					{
						title: 'No. PO',
						render: (_, record) => record.purchaseOrderNo ?? '-',
					},
					{
						title: 'Supplier',
						render: (_, record) => record.supplierName ?? '-',
					},
					{
						title: 'Merk Asset',
						render: (_, record) => record.assetName ?? '-',
					},
					{
						title: 'Tanggal Terbit PO',
						render: (_, record) =>
							record.tanggalTerbitPo
								? dayjs(record.tanggalTerbitPo).format('DD/MM/YYYY')
								: '-',
					},
					{
						title: 'Tanggal PO Expired',
						render: (_, record) =>
							record.tanggalPoExpired
								? dayjs(record.tanggalPoExpired).format('DD/MM/YYYY')
								: '-',
					},
					{
						title: 'Status  PO',
						render: (_, record) => record.statusPo ?? '-',
					},
					{
						title: 'Tanggal Update',
						render: (_, record) =>
							record.tanggalUpdate
								? dayjs(record.tanggalUpdate).format('DD/MM/YYYY')
								: '-',
					},
					{
						title: 'NTF',
						render: () => '-',
					},
					{
						title: 'Jumlah Unit',
						render: (_, record) => record.jumlahUnit ?? '-',
					},
				]}
			/>
		</Fragment>
	);
};

export default MonitoringPlafondPO;
